// 2026 NP/PA practice-authority: states requiring a supervising/collaborating physician
// (reduced + restricted practice) for mid-level prescribers. Mirrors backend supervision_rules.py.
export const SUPERVISION_REQUIRED_STATES = new Set([
    // reduced practice (collaborative agreement)
    "AL", "AR", "IL", "IN", "KY", "LA", "MS", "NJ", "OH", "PA", "WV", "WI",
    // restricted practice (physician supervision)
    "CA", "FL", "GA", "MI", "MO", "NC", "OK", "SC", "TN", "TX", "VA",
]);

const PHYSICIAN_CREDENTIALS = new Set(["MD", "DO", "DDS", "DMD", "MBBS"]);

const NAME_TO_ABBR = {
    alabama: "AL", alaska: "AK", arizona: "AZ", arkansas: "AR", california: "CA",
    colorado: "CO", connecticut: "CT", delaware: "DE", florida: "FL", georgia: "GA",
    hawaii: "HI", idaho: "ID", illinois: "IL", indiana: "IN", iowa: "IA", kansas: "KS",
    kentucky: "KY", louisiana: "LA", maine: "ME", maryland: "MD", massachusetts: "MA",
    michigan: "MI", minnesota: "MN", mississippi: "MS", missouri: "MO", montana: "MT",
    nebraska: "NE", nevada: "NV", "new hampshire": "NH", "new jersey": "NJ",
    "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND",
    ohio: "OH", oklahoma: "OK", oregon: "OR", pennsylvania: "PA", "rhode island": "RI",
    "south carolina": "SC", "south dakota": "SD", tennessee: "TN", texas: "TX", utah: "UT",
    vermont: "VT", virginia: "VA", washington: "WA", "west virginia": "WV", wisconsin: "WI",
    wyoming: "WY", "district of columbia": "DC",
};

export function normState(value) {
    if (!value) return "";
    const s = String(value).trim();
    if (s.length === 2) return s.toUpperCase();
    return NAME_TO_ABBR[s.toLowerCase()] || s.slice(0, 2).toUpperCase();
}

export function isPhysician(credentials) {
    if (!credentials) return false;
    const tokens = String(credentials).replace(/[.\-]/g, " ").toUpperCase().split(/\s+/);
    return tokens.some((t) => PHYSICIAN_CREDENTIALS.has(t));
}

// Returns the matched required states (empty array = not required).
export function supervisionTriggerStates(credentials, states) {
    if (isPhysician(credentials)) return [];
    const list = Array.isArray(states) ? states : [states];
    return [...new Set(list.map(normState).filter((s) => s && SUPERVISION_REQUIRED_STATES.has(s)))];
}
